module.exports = __webpack_public_path__ + "img/littlecar_white.f42c2d67.png";